import { connect } from 'react-redux';
import { goToEdit } from '../../ManageServices.saga';
import { selectSelectedPractitioner } from '../Practitioners.selectors';
import PractitionerDetails from './PractitionerDetails';

const mapStateToProps = state => ({
  practitioner: selectSelectedPractitioner(state),
});

const mapDispatchToProps = {
  handleEditClick: goToEdit,
};

export default connect(mapStateToProps, mapDispatchToProps)(PractitionerDetails);
